<!-- 文件中文名: 经销商注册成功(印度专属) -->
<template>
  <div class="register-success app-container">
    <app-breadcrumb/>
    <div class="page-container recharge-manage">
      <p>{{ $t('info.register.success') }}</p>
      <p style="height: 24px;line-height: 24px">{{ $t('miMember.memberNo') }}: <span style="font-weight: 700;color: red">{{ memberNo }}</span></p>
      <el-divider />
      <div style="text-align: center">
        <!-- 确认  /  现在登录 -->
        <el-button type="primary" icon="el-icon-right" @click="goLogin">{{ userCode ? $t('button.confirm') : $t('info.login.now') }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>

import {getLanguage} from "@/lang"
import {mapGetters} from "vuex";

export default {
  name: 'RegisterSuccess',
  data() {
    return {
      memberNo: ''
    }
  },
  computed: {
    ...mapGetters([
      'userCode',
    ])
  },
  async created() {
    this.$route.query.memberNo ? this.memberNo = this.$route.query.memberNo : await this.$router.push({path: '/login'})
    if (!this.userCode) {
      this.$i18n.locale = this.$route.query.language.toString()
      await getLanguage()
    }
  },
  methods: {
    goLogin() {
      const input = document.createElement('input');
      input.setAttribute('readonly', 'readonly')
      input.setAttribute('value', this.memberNo)
      document.body.appendChild(input)
      input.select()
      if (document.execCommand('copy')) {
        document.execCommand('copy')
      }
      document.body.removeChild(input);
      this.$message.success(this.$t('miMember.memberNo') + this.$t('button.copy') + this.$t('Common.success')) // 经销商编号复制成功
      if (this.userCode) {
        this.$router.push({name: 'Home'})
      } else {
        this.$router.push({path: '/login'})
      }

    }
  }
}

</script>

<style scoped>

</style>
